import { apiClient } from '@/lib/api-client';

export interface Party {
  id: string;
  tenantId: string;
  docType: 'DNI' | 'RUC' | 'CE' | 'PASAPORTE' | 'OTROS';
  docNumber: string;
  name: string;
  tradeName: string | null;
  email: string | null;
  phone: string | null;
  address: string | null;
  ubigeoCode: string | null;
  isCustomer: boolean;
  isSupplier: boolean;
  notes: string | null;
  createdAt: string;
  updatedAt: string;
}

export interface PartyListResponse {
  items: Party[];
  total: number;
  page: number;
  pageSize: number;
}

export interface PartyInput {
  docType: Party['docType'];
  docNumber: string;
  name: string;
  tradeName?: string | null;
  email?: string | null;
  phone?: string | null;
  address?: string | null;
  ubigeoCode?: string | null;
  isCustomer: boolean;
  isSupplier: boolean;
  notes?: string | null;
}

export interface PartyListParams {
  page?: number;
  pageSize?: number;
  search?: string;
  role?: 'customer' | 'supplier' | 'any';
}

export async function listParties(params: PartyListParams = {}): Promise<PartyListResponse> {
  const { data } = await apiClient.get<PartyListResponse>('/parties', { params });
  return data;
}

export async function createParty(input: PartyInput): Promise<Party> {
  const { data } = await apiClient.post<Party>('/parties', input);
  return data;
}

export async function updateParty(id: string, input: Partial<PartyInput>): Promise<Party> {
  const { data } = await apiClient.patch<Party>(`/parties/${id}`, input);
  return data;
}

export async function deleteParty(id: string): Promise<void> {
  await apiClient.delete(`/parties/${id}`);
}
